// extracted by mini-css-extract-plugin
export default {"header":"Header_header__HXQOm","gradient":"Header_gradient__-yf6M","fffLogo":"Header_fffLogo__lut+8"};